<template>
  <li>
    <span>
      {{ this.labelname }}
      <!-- 		 <template v-if="fieldname == 'expirationDate'">
		<br>
			<small>
				YYYY-MM Format
			</small>
		</template> -->
    </span>
    <span>
      <input
        :type="fieldtype"
        v-if="edit"
        v-model="valueLocal"
        @blur="blurMethod('blur')"
        @keyup.enter="enterMethod('enter')"
        @keyup.esc="escMethod('esc')"
        v-focus=""
      />

      <span v-else-if="this.fieldtype == 'text'">
        {{ valueLocal }}
      </span>
      <span v-else="">*********************</span>
    </span>
    <span>
      <a class="vue-anchor" @click="editClick()">
        <span class="icon-edit"></span>
        Edit
      </a>
    </span>
  </li>
</template>

<script>
  export default {
    props: {
      labelname: {
        type: String,
        default: 'Label',
      },
      fieldtype: {
        type: String,
        default: 'text',
      },
      fieldname: {
        type: String,
        default: 'fieldname',
      },
      propvalue: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        edit: false,
        valueLocal: this.propvalue,
        valueOriginal: this.propvalue,
        edit: false,
        isblur: 0,
        value: this.propvalue,
      };
    },

    watch: {
      value: function () {
        this.valueLocal = this.value;
      },
    },

    directives: {
      focus: {
        inserted(el) {
          el.focus();
        },
      },
    },

    methods: {
      editClick: function () {
        this.valueOriginal = this.value;
        this.edit = true;
        this.isblur = 0;
      },

      blurMethod: function (type) {
        if (this.isblur === 0) {
          switch (type) {
            case 'blur':
              this.update();

              break;
            case 'enter':
              this.update();
              this.isblur = 1;
              this.edit = false; //this triggers blur again which is why we have the isblur check
              break;

            case 'esc':
              this.valueLocal = this.valueOriginal;
              this.isblur = 1;
              this.edit = false; //this triggers blur again which is why we have the isblur check

              break;

            default:
              this.isblur = 1;
              this.edit = false;
          } //end case
          return;
        } else {
          return;
        } //end if
      },
      update: function () {
        var field =
          'set' +
          this.fieldname.charAt(0).toUpperCase() +
          this.fieldname.slice(1);

        axios
          .post('/authnet/update-customer-payment-profile', {
            // _token: this._token,
            [field]: this.valueLocal,
          })
          .then((success) => {
            this.isblur = 1;
            this.edit = false; //this triggers blur again which is why we have the isblur check
          })
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      enterMethod: function (type) {
        this.blurMethod(type);
      },
      escMethod: function (type) {
        this.blurMethod(type);
      },
    }, //end methods
  }; //end export defaults
</script>
